import FiltersPanel from "./FiltersPanel.vue";

export default FiltersPanel;
